export const HYDRA_MEMBER = 'hydra:member';
export const HYDRA_VIEW = 'hydra:view';
export const HYDRA_DESCRIPTION = 'hydra:description';
export const HYDRA_TOTAL_ITEMS = 'hydra:totalItems';
export const HYDRA_ID = '@id';



// WEBPACK FOOTER //
// ./src/constants/hydra.js